import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, CssBaseline, Grid, IconButton, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticData from "../../../data/StaticData";
import { DataGrid } from "@mui/x-data-grid";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";
import { MdDelete, MdEditSquare } from "react-icons/md";
import { string } from "prop-types";

const EditFlightComAccomodation = ({ flightData }) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const { setOpen } = useContext(ContextNotification);
    const customization = useSelector((state) => state.customization);
    const [isloading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [brokers, setBrokers] = useState([]);
    const [freePassengers, setFreePassengers] = useState([]);
    const schema = yup.object().shape({
        hotelName: yup.string().required('هتل مورد نظر را انتخاب  نمائید'),
        numberOfRooms: yup.string().required(' تعداد اتاق را وارد نمائید'),
        roomRate: yup.string().required(' نرخ اتاق را مشخص نمائید'),
        lengthOfStay: yup.string().required(' مدت اقامت را وارد نمائید'),

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),
    });
    const Columns = [
        {  headerName: "نام کارگزاری", width: '200',renderCell: (cellValues) =>{return cellValues.row.kargozarCode!=null? cellValues.row.kargozarCode+' - '+cellValues.row.brokerGroupCode+' - '+cellValues.row.kargozarName:''} },
         { field: "fullName", headerName: " نام مسافر آزاد", width: '150' },
        // { field: "hotelName", headerName: " نام هتل", width: '100' },
        // { field: "numberOfRooms", headerName: "تعداد اتاق", width: '100' },
        // { field: "roomRate", headerName: "نرخ اتاق", width: '100' },
        // { field: "lengthOfStay", headerName: "(شب) مدت اقامت", width: '150' }
    ];
    Columns.push({
        field: "ویرایش", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isloading}
                    sx={{ color: '#4a148c' }}
                    onClick={() => {
                        handleOpenEdit(cellValues.row)
                    }}><MdEditSquare />
                </IconButton>
            )
        }
    });
    Columns.push({
        field: "حذف", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isloading}
                    sx={{ color: '#c70c05c2' }}
                    onClick={() => {
                        handleOpenDelete(cellValues.row)
                    }}><MdDelete />
                </IconButton>
            )
        }
    });
    const resetForm = () => {
        setValue("hotelName", null);
        setValue("numberOfRooms", null);
        setValue("roomRate", null);
        setValue("lengthOfStay", null);
        setOpenDelete(false);
        setDeleteData(null);
        setSelectedCompensation(null);
        GetData();
    }
    useEffect(() => {
        GetData();
        setBrokers(flightData?.tripGroupMembersResponses?.filter((itm) => itm.brokerCode !== null).map((o) => {
            return {
                id: o.brokerId,
                label: o.brokerCode + '-' + o.brokerName
            };
        }));
        setFreePassengers(flightData?.tripPassengerMembersResponses?.filter(itm => (itm.flightAttendanceStatus === false)).map((o) => {
            return {
                id: o.passengerId,
                label: o.sSn + '-' + o.fullName
            };
        }));

    }
    

        , [flightData])


    const GetData = () => {
        if (flightData?.flightId) {
            setIsLoading(true);
            FlightCompensationApi.GetFlightCompAccomodationByFlightId(flightData?.flightId).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setRows(res.data.data);

                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در دریافت اطلاعات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setIsLoading(false) });
        }
        else {
            setRows([]);
        }
    }

    ///delete/////////////////////////////////////
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteDate, setDeleteData] = useState(null);
    const handleOpenDelete = (data) => {
        setOpenDelete(true);
        setDeleteData(data);
    };
    const handleDeleteRow = () => {
        setIsLoading(true);
        FlightCompensationApi.deleteFlightCompAccomodation(deleteDate.id).then(res => {
            if (res.status === 200) {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت حذف شد', severity: severitys.success });
                    resetForm();

                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

                }

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => { setIsLoading(false) });
    }
    ////////Edit/////////////////////////
    const [selectedCompensation, setSelectedCompensation] = useState(null);
    const handleOpenEdit = (data) => {
        if (selectedCompensation?.id === data.id) {
            setSelectedCompensation(null);
            setValue("hotelName", null);
            setValue("numberOfRooms", null);
            setValue("roomRate", null);
            setValue("lengthOfStay", null);
        }
        else {
            setSelectedCompensation(data);
            setValue("hotelName", String(data.hotelName));
            setValue("numberOfRooms", (data.numberOfRooms !== null) ? String(data.numberOfRooms) : null);
            setValue("roomRate", (data.roomRate !== null) ? String(data.roomRate) : null);
            setValue("lengthOfStay", (data.lengthOfStay !== null) ? String(data.lengthOfStay) : null);

        }

    }

    ////////////////////////

    const DoSave = (data) => {
        var pbrokerGroupNo = null;
        var pbrokerID = null;
        if (data.brokerID) {
            var broker = flightData?.tripGroupMembersResponses?.find((itm) => itm.brokerId === data.brokerID);
            pbrokerGroupNo = String(broker.groupNo);
            pbrokerID = String(data.brokerID);
        }
        var ppassengerId = null;
        if (data.passengerID)
            ppassengerId = String(data.passengerID);
        var photelName = null;
        if (data.hotelName)
            photelName = String(data.hotelName);
        var pnumberOfRooms = null;
        if (data.numberOfRooms)
            pnumberOfRooms = parseInt(data.numberOfRooms)
        var proomRate = null;
        if (data.roomRate)
            proomRate = parseInt(data.roomRate)
        var plengthOfStay = null;
        if (data.lengthOfStay)
            plengthOfStay = parseInt(data.lengthOfStay)

        const compdata = {
            'hotelName': photelName,
            'numberOfRooms': pnumberOfRooms,
            'roomRate': proomRate,
            'lengthOfStay': plengthOfStay,
            "brokerId": pbrokerID,
            "passengerId": ppassengerId,
            "brokerGroupNo": pbrokerGroupNo
        }
        setSubmitLoading(true);

        if (selectedCompensation === null)//add mode
        {
            FlightCompensationApi.AddFlightCompAccomodation(flightData.flightId, compdata).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: 'هزینه با موفقیت افزوده شد', severity: severitys.success });
                        resetForm();
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setSubmitLoading(false) });
        }
        else {
            FlightCompensationApi.UpdateFlightCompAccomodation(selectedCompensation?.id, compdata).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: 'ویرایش هزینه با موفقیت انجام شد', severity: severitys.success });
                        resetForm();
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setSubmitLoading(false) });
        }

    }




    const handleChangenumberOfRooms = (value) => {
        if ((value !== null) && (parseInt(value) > 0)) {
            setValue("numberOfRooms", value);
        }
        else {
            setValue("numberOfRooms", null);
        }
    }
    const handleChangeroomRate = (value) => {
        if ((value !== null) && (parseInt(value) > 0)) {
            setValue("roomRate", value);
        }
        else {
            setValue("roomRate", null);
        }
    }
    const handleChangelengthOfStay = (value) => {
        if ((value !== null) && (parseInt(value) > 0)) {
            setValue("lengthOfStay", value);
        }
        else {
            setValue("lengthOfStay", null);
        }
    }
    const handlebrokerIDChanged = () => {


        if ((watch("brokerID")) && (watch("brokerID") !== null)) {
            setValue("passengerID", null);
        }

    }
    const handlepassengerIDChanged = () => {
        if ((watch("passengerID")) && (watch("passengerID") !== null)) {
            setValue("brokerID", null);
        }

    }

    return (
        <Box sx={{ m: 2 }}>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                    <form onSubmit={handleSubmit(DoSave)}>
                        <Grid container spacing={1}>
                            {(selectedCompensation === null) && <> <Grid container spacing={1} m={1}>
                                <Grid item md={2.5} xs={7}>
                                    <RHFAutocomplete
                                    focused={(selectedCompensation!==null)}
                                        control={control}
                                        options={brokers ?? []}
                                        name="brokerID"
                                        onChange={handlebrokerIDChanged}
                                        placeholder="گروه"
                                        style={{
                                            border: "none",
                                            padding: 0
                                        }}
                                    />
                                                {((!watch("brokerID"))||(watch("brokerID")===null))&&((!watch("passengerID"))||(watch("passengerID")===null)) &&
                                                            <p  className="error">{' شماره گروه یا  مسافر آزاد را مشخص کنید'}</p>
                                                        }
                                </Grid>
                                <Grid item md={2.5} xs={7}>
                                    <RHFAutocomplete
                                    focused={(selectedCompensation!==null)}
                                        disabled={selectedCompensation !== null}
                                        control={control}
                                        options={freePassengers ?? []}
                                        name="passengerID"
                                        onChange={handlepassengerIDChanged}
                                        placeholder="مسافر آزاد"
                                        style={{
                                            border: "none",
                                            padding: 0
                                        }}
                                    />
                                </Grid>
                            </Grid>
 
                            </>
                            }

                            {
                                (selectedCompensation?.kargozarCode) && <Grid item md={12} xs={12}><Typography sx={{ m: 1 }}>{selectedCompensation?.kargozarCode + '-' + selectedCompensation?.kargozarName}</Typography></Grid>
                            }
                            {
                                (selectedCompensation?.fullName) && <Grid item md={12} xs={12}><Typography sx={{ m: 1 }}>{selectedCompensation?.fullName}</Typography></Grid>
                            }
                            <Grid item md={2.5} xs={7}>
                                <TextField
                                    label=" نام هتل "
                                    focused={(selectedCompensation!==null)}
                                    {...register("hotelName")}
                                    fullWidth></TextField>
                                <p className="error">{errors.hotelName?.message}</p>
                            </Grid>
                            <Grid item md={1.5} xs={7}>
                                <TextField
                                    type="number"
                                    label=" تعداد اتاق  "
                                    focused={(selectedCompensation!==null)}
                                    {...register("numberOfRooms")}
                                    onChange={(event) => { handleChangenumberOfRooms(event.target.value); }}
                                    fullWidth></TextField>
                                <p className="error">{errors.numberOfRooms?.message}</p>
                            </Grid>
                            <Grid item md={2.5} xs={7}>
                                <TextField
                                    type="number"
                                    label=" نرخ اتاق  "
                                    focused={(selectedCompensation!==null)}
                                    {...register("roomRate")}
                                    onChange={(event) => { handleChangeroomRate(event.target.value); }}
                                    fullWidth></TextField>
                                <p className="error">{errors.roomRate?.message}</p>
                            </Grid>
                            <Grid item md={1.5} xs={7}>
                                <TextField
                                    type="number"
                                    label="تعداد شب اقامت "
                                    focused={(selectedCompensation!==null)}
                                    {...register("lengthOfStay")}
                                    onChange={(event) => { handleChangelengthOfStay(event.target.value); }}
                                    fullWidth></TextField>
                                <p className="error">{errors.lengthOfStay?.message}</p>
                            </Grid>
                            <Grid item md={7} xs={7.5}>
                                <Button type="submit" disabled={submitLoading} sx={{ mt: 1 }} variant="contained" color="primary" fullwidth >
                                    <BeatLoading loading={submitLoading} color={"#e65100"} /> {(selectedCompensation !== null) ? 'ویرایش' : 'ثبت'}</Button>
                            </Grid>
                        </Grid>
                        <Paper sx={{ mt: 2, width: "100%", height: "500px" }}>
                            <DataGrid
                                rows={rows}
                                columns={Columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 50,
                                        },
                                    },
                                }}
                                pageSizeOptions={[25, 50, 100]}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                disableColumnSelector
                                loading={isloading}
                                sx={{
                                    backgroundColor: '#F1F1E8', // Set your desired background color    
                                    '& .MuiDataGrid-columnHeaders > div[role="row"]': {
                                        color: '#F1F1E8!important',
                                        backgroundColor: '#50a193ff!important',
                                    },
                                }}
                            />
                        </Paper >
                        <ConfirmationDialog
                            open={openDelete}
                            handleClose={() => setOpenDelete(false)}
                            deleteFunction={handleDeleteRow}
                        />
                    </form>
                </RtlProvider>
            </ThemeProvider>
        </Box >
    )
}
export default EditFlightComAccomodation;